import { FormAppearance } from '@/features/MarketoForm/MarketoForm.interface';
import { useCallback, useMemo } from 'react';
import { mapColorNameToTheme } from '@/utils/helpers';

export const useAppearanceTheme = (appearance: Partial<FormAppearance> = {}, theme: Theme) => {
  return useMemo(() => {
    if (!appearance || !appearance.backgroundColor) return theme;
    return mapColorNameToTheme(appearance.backgroundColor);
  }, [theme, appearance]);
};

export const useMarketoLogic = () => {
  const hasMarketoError = useCallback((mutations: MutationRecord[]) => {
    const addedErrors = mutations.filter((mutation) =>
      Array.from(mutation.addedNodes).some((node) => {
        const htmlNode = node as HTMLElement;
        return htmlNode?.classList && htmlNode.classList.contains('mktoError');
      }),
    );
    return !!addedErrors.length;
  }, []);

  return { hasMarketoError };
};
